<template>
    <div class="o-dashboard">
        <c-loader-container :loading="loading">
            <div class="o-dashboard__breadcrumbs" v-if="request">
                <c-breadcrumbs></c-breadcrumbs>
            </div>

            <div class="o-dashboard__panels" v-if="request">
                <div class="row collapse">
                    <div class="column small-12 xlarge-8">
                        <div class="c-panel c-panel--border c-panel--expand margin-b-24">
                            <div class="row">
                                <div class="columns">
                                    <h2 class="margin-b-4">{{request.kenmerk}}</h2>
                                    <div class="fs-small color-dark-gray">Aangevraagd op: {{request.created_at | datetime}}</div>
                                    <div v-if="user.is_planner" class="fs-small color-dark-gray">Aangevraagd door:
                                        {{request.opdrachtgever.user.name }} ({{request.opdrachtgever.organisatie.naam}})</div>
                                </div>
                                <div class="columns shrink">
                                    <c-status-label :target="request" :label="true"></c-status-label>
                                </div>
                            </div>

                            <div class="margin-t-24">
                                <c-splitbutton :buttons="buttons"></c-splitbutton>
                            </div>

                            <div class="margin-t-24" v-if="showRequestDetail">
                                <div class="c-request-info fs-small">

                                    <div class="row margin-b-16" v-if="atLocation">
                                        <div class="columns small-12 medium-4">
                                            <span class="color-dark-gray">Datum tolkdienst</span>
                                        </div>
                                        <div class="columns small-12 medium-8">
                                            {{request.begintijd | date}}
                                        </div>
                                    </div>

                                    <div class="row margin-b-16" v-if="atLocation">
                                        <div class="columns small-12 medium-4">
                                            <span class="color-dark-gray">Begintijd</span>
                                        </div>
                                        <div class="columns small-12 medium-8">
                                            {{request.begintijd | time}}
                                        </div>
                                    </div>

                                    <div class="row margin-b-16" v-if="atLocation">
                                        <div class="columns small-12 medium-4">
                                            <span class="color-dark-gray">Eindtijd</span>
                                        </div>
                                        <div class="columns small-12 medium-8">
                                            {{request.eindtijd | time}}
                                        </div>
                                    </div>

                                    <div class="row margin-b-16">
                                        <div class="columns small-12 medium-4">
                                            <span class="color-dark-gray">Brontaal</span>
                                        </div>
                                        <div class="columns small-12 medium-8">
                                            {{ sourceLanguage }}
                                        </div>
                                    </div>

                                    <div class="row margin-b-16">
                                        <div class="columns small-12 medium-4">
                                            <span class="color-dark-gray">Doeltaal</span>
                                        </div>
                                        <div class="columns small-12 medium-8">
                                            {{ targetLanguages }}
                                        </div>
                                    </div>

                                    <div class="row margin-b-16" v-if="atLocation">
                                        <div class="columns small-12 medium-4">
                                            <span class="color-dark-gray">Aanwezigheid</span>
                                        </div>
                                        <div class="columns small-12 medium-8">
                                            {{request.type_aanwezigheid}}
                                        </div>
                                    </div>

                                    <div class="row margin-b-16" v-if="atLocation">
                                        <div class="columns small-12 medium-4">
                                            <span class="color-dark-gray">Locatie</span>
                                        </div>
                                        <div class="columns small-12 medium-8">
                                            {{ request.adres ? request.adres.locatie : request.opdrachtgever.adres.locatie}}
                                        </div>
                                    </div>


                                    <div class="row margin-b-16" v-if="!atLocation">
                                        <div class="columns small-12 medium-4">
                                            <span class="color-dark-gray">Deadline</span>
                                        </div>
                                        <div class="columns small-12 medium-8">
                                            {{ request.deadline | datetime }}
                                        </div>
                                    </div>

                                    <div class="row margin-b-16">
                                        <div class="columns small-12 medium-4">
                                            <span class="color-dark-gray">Administratief kenmerk</span>
                                        </div>
                                        <div class="columns small-12 medium-8">
                                            {{ request.kenmerk }}
                                        </div>
                                    </div>

                                    <div class="row margin-b-16" v-if="atLocation">
                                        <div class="columns small-12 medium-4">
                                            <span class="color-dark-gray">Naam gesprekspartner</span>
                                        </div>
                                        <div class="columns small-12 medium-8">
                                            {{ request.naam_gespreksvoerder }}
                                        </div>
                                    </div>

                                    <div class="row margin-b-16" v-if="atLocation">
                                        <div class="columns small-12 medium-4">
                                            <span class="color-dark-gray">Opdrachtgever telefoon nummer</span>
                                        </div>
                                        <div class="columns small-12 medium-8">
                                            {{ request.opdrachtgever_telefoon }}
                                        </div>
                                    </div>

                                    <div class="row margin-b-16" v-if="atLocation">
                                        <div class="columns small-12 medium-4">
                                            <span class="color-dark-gray">Opdrachtnemer telefoon nummer</span>
                                        </div>
                                        <div class="columns small-12 medium-8">
                                            {{ request.opdrachtnemer_telefoon }}
                                        </div>
                                    </div>

                                    <div class="row margin-b-16">
                                        <div class="columns small-12 medium-4">
                                            <span class="color-dark-gray">Opmerking en instructies</span>
                                        </div>
                                        <div class="columns small-12 medium-8">
                                            {{ request.instructies }}
                                            {{ ownAssignment ? ownAssignment.instructies : '' }}
                                        </div>
                                    </div>

                                    <div class="row" v-if="user.is_planner">
                                        <div class="columns small-12 medium-4">
                                            <span class="color-dark-gray">Notities</span>
                                        </div>
                                        <div class="columns small-12 medium-8">
                                            {{ request.notitie ? request.notitie : '-'}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <template v-if="atLocation">

                            <div class="c-panel c-panel--border c-panel--expand margin-b-24" v-if="accepted.length == 0 && !withdrawn">
                                <h2>{{ user.is_applicant ? 'Je aanvraag is in afwachting' : 'De aanvraag is in afwachting' }}</h2>
                                <div class="c-callout no-margin">
                                    <span>Nog geen tolk beschikbaar…</span>
                                </div>
                            </div>

                            <div class="c-panel c-panel--light-gray c-panel--expand margin-b-24" v-else-if="accepted.length > 0 && !withdrawn && !finished">
                                <h2>De opdracht is geaccepteerd</h2>
                                <span>{{acceptedText}}</span>
                            </div>

                            <div class="c-panel c-panel--light-gray c-panel--expand margin-b-24" v-else-if="accepted.length > 0 && !withdrawn && finished">
                                <h2>De opdracht is gereed</h2>
                                <span></span>
                            </div>

                            <div class="c-panel c-panel--alert c-panel--expand margin-b-24" v-else-if="withdrawn">
                                <h2>De aanvraag is niet meer beschikbaar</h2>
                                <span>De aanvraag is door de planner of de aanvrager geannuleerd.</span>
                            </div>
                        </template>

                        <template v-else-if="user.is_applicant || user.is_planner || ownAssignment == null || ownAssignment.is_verlopen == false">
                            <div class="c-panel c-panel--border c-panel--expand margin-b-24" v-if="request.vertalingen.length > 0">
                                <h2>Vertalingen</h2>
                                <c-block-files
                                    v-for="translation in request.vertalingen"
                                    :title="translation.doeltaal.taal"
                                    :files="files(translation)"
                                    :deletable="true"
                                    :downloadable="user.is_applicant || user.is_planner || ( !completed && !withdrawn )"
                                    :anonymous="!ownAssignment && !isOwnRequest && request.is_anoniem"
                                    :upload="ownAssignment && ownAssignment.vertaling_id == translation.id && ownAssignment.geaccepteerd_at !== null && !completed && !withdrawn"
                                    :assignment="ownAssignment"
                                    :key="'files-' + translation.id"
                                    :deleted="Boolean(translation.deleted_at)">
                                </c-block-files>
                            </div>

                            <div class="c-panel c-panel--border c-panel--expand margin-b-24">
                                <h2 class="margin-b-32">Aangeleverde bestanden</h2>
                                <c-block-files
                                    :title="'Bronbestanden'"
                                    :files="sourcefiles"
                                    :downloadable="user.is_applicant || user.is_planner || ( !completed && !withdrawn )"
                                    :deletable="user.is_applicant || user.is_planner"
                                    :anonymous="!ownAssignment && !isOwnRequest && request.is_anoniem"
                                >
                                </c-block-files>
                                <c-block-files
                                    :title="'Referentiemateriaal'"
                                    :files="referencefiles"
                                    :downloadable="user.is_applicant || user.is_planner || ( !completed && !withdrawn )"
                                    :deletable="user.is_applicant || user.is_planner"
                                    :anonymous="!ownAssignment && !isOwnRequest && request.is_anoniem"
                                >
                                </c-block-files>
                            </div>
                        </template>
                    </div>

                    <div class="column small-12 xlarge-4">

                        <template v-if="ownAssignment && !withdrawn">
                            <c-block-completed
                                :words="ownAssignment.aantal_woorden"
                                :sworn="ownAssignment.aantal_beedigingen"
                                :date="ownAssignment.klaar_at"
                                v-if="ownAssignment.klaar_at">
                            </c-block-completed>

                            <c-block-complete
                                :request="request"
                                :assignment="ownAssignment"
                                v-else-if="ownAssignment.geaccepteerd_at &&
                                    (( request.is_tolk_opdracht && request.is_verlopen_begintijd) ||
                                    ( !request.is_tolk_opdracht && ownAssignment.media.length > 0 ))">
                            </c-block-complete>
                            <c-block-accepted
                                :request="request"
                                v-else-if="ownAssignment.geaccepteerd_at">
                            </c-block-accepted>
                            <c-block
                                v-else-if="ownAssignment.afgewezen_at"
                                title="Afgewezen">
                                De aanvraag is afgewezen.
                            </c-block>
                            <c-block
                                v-else-if="ownAssignment.is_verlopen"
                                title="Verlopen">
                                De tijd om deze opdracht te accepteren is verlopen.
                            </c-block>
                            <c-block-accept
                                :assignment="ownAssignment"
                                :request="request" v-else>
                            </c-block-accept>
                        </template>

                        <!-- Planner blocks -->
                        <template v-if="user.is_planner && !withdrawn">
                            <c-block-assigned :request="request"></c-block-assigned>
                        </template>
                        <c-block-messages
                            v-if="!withdrawn"
                            :count="messages"
                            :route="user.is_planner ? { name: 'chat-overview', params: { id: $route.params.id } } : ownAssignment ? { name: 'chat', params: { id: $route.params.id }, query: { assigment: ownAssignment.id } } : { name: 'chat', params: { id: $route.params.id } }">
                        </c-block-messages>

                        <c-block-activities v-if="showActivities"
                                            :activities="request.activiteiten">
                        </c-block-activities>
                    </div>
                </div>
                <c-request
                    :edit="request"
                    ref="editmodal"
                    v-show="modal.edit"
                    @close="modal.edit=false"
                    @update="reload">
                </c-request>
                <c-reject
                    ref="rejectmodal"
                    v-show="modal.reject"
                    @close="modal.reject=false"
                    @submit="reject">
                </c-reject>
            </div>
        </c-loader-container>
    </div>
</template>

<script>
import CBreadcrumbs from '@components/Breadcrumbs.vue';
import CLoaderContainer from '@components/loader/Container.vue';
import CSplitbutton from '@components/Splitbutton.vue';
import CStatusLabel from '@components/StatusLabel.vue'

import CBlockMessages from '@components/blocks/Messages.vue';
import CBlockActivities from '@components/blocks/Activities.vue';
import CBlockComplete from '@components/blocks/Complete.vue';
import CBlockCompleted from '@components/blocks/Completed.vue';
import CBlockAssigned from '@components/blocks/Assigned.vue';
import CBlockAccept from '@components/blocks/Accept.vue';
import CBlockAccepted from '@components/blocks/Accepted.vue';
import CBlockFiles from '@components/blocks/Files.vue';
import CBlock from '@components/blocks/Block.vue';

import CRequest from '@app/modals/Request.vue';
import CReject from '@app/modals/Reject.vue';

import { mapState } from 'vuex';

import Form from '@mixins/Form';
import View from '@mixins/View';

export default {
    components: {
        CBreadcrumbs,
        CLoaderContainer,
        CSplitbutton,
        CBlockMessages,
        CBlockActivities,
        CBlockComplete,
        CBlockCompleted,
        CBlockAssigned,
        CBlockAccept,
        CBlockAccepted,
        CBlockFiles,
        CRequest,
        CStatusLabel,
        CBlock,
        CReject
    },
    mixins: [ Form, View ],
    data() {
        return {
            loading: true,
            modal: {
                assign: false,
                service: false,
                edit: false,
                reject: false
            },
            showRequestDetail: false
        }
    },
    methods: {
        edit() {
            this.modal.edit = true;
        },
        cancel() {
            this.$xhr.post('/api/request-detail/' + this.$route.params.id + '/withdraw/', {opdracht: this.request.id}).then( () => {

                this.$store.dispatch('request/changeAssignment');

                this.$store.dispatch('toasts/success', {title: 'Opdracht ingetrokken', text: 'Je hebt de opdracht ingetrokken'});
                this.$router.push({path:'/'});

            }).catch( (e)=> {
                this.$store.dispatch('toasts/alert', {title: 'Opdracht ingetrokken', text: 'Helaas kon de opdracht niet ingetrokken worden'});
            });
        },
        wrapUp() {
            this.$xhr.post('/api/request-detail/' + this.$route.params.id + '/complete/').then( () => {

                this.$store.dispatch('request/changeAssignment');

                this.$store.dispatch('toasts/success', {title: 'Opdracht afgerond', text: 'Je hebt de opdracht afgerond'});

            }).catch( (e)=> {
                this.$store.dispatch('toasts/alert', {title: 'Opdracht afgerond', text: 'Helaas kon de opdracht niet afgerond worden'});
            });
        },

        reject(remark) {
            this.$xhr.post('/api/request-detail/' + this.$route.params.id + '/reject/', {remark}).then( () => {

                this.$store.dispatch('request/changeAssignment');
                this.modal.reject = false;
                this.$store.dispatch('toasts/success', {title: 'Opdracht afgekeurd', text: 'Je hebt de opdracht afgekeurd'});

            }).catch( (e)=> {
                this.$store.dispatch('toasts/alert', {title: 'Opdracht afgekeurd', text: 'Helaas kon de opdracht niet afgekeurd worden'});
            });
        },
        reload() {

            this.loading = true;

            this.$store.dispatch('request/reload').then( () => {
                this.loading = false;
            }).catch( (e) => {

                this.$store.dispatch('toasts/alert', {title: 'Aanvraag laden', text: 'Helaas kon de aanvraag niet geladen worden'});
            });
        },

        files(translation) {
            let media = [];

            translation.opdrachtnemers.forEach( (t) => {
                let newMedia = t.media.filter( m => m.collection_name == 'vertalingen' );

                if ( !this.user.is_planner && this.user.is_applicant ) {
                    newMedia = newMedia.filter((m) => (this.completed && t.klaar_at) || this.user.opdrachtnemer?.id == t.opdrachtnemer_id );
                }

                media = [ ...media, ...newMedia ];
            });

            return media;
        }
    },
    computed: {
        showActivities(){
            return this.user.is_planner || this.user.is_management;
        },
        messages() {
            if ( this.user.is_planner ) {
                return this.totalTranslatorMessages + this.request.berichten_count;
            }
            else if ( this.ownAssignment ) {
                return this.ownAssignmentMessages;
            }
            else {
                return this.request.berichten_count;
            }
        },
        totalTranslatorMessages() {
            let messages = 0;

            if ( Array.isArray(this.request.vertalingen) ) {
                this.request.vertalingen.forEach( (v) => {
                    if ( Array.isArray(v.opdrachtnemers) && v.opdrachtnemers.length ) {
                        v.opdrachtnemers.forEach( (o) => {
                            messages += o.berichten_count;
                        });
                    }
                });
            }

            return messages;
        },
        ownAssignmentMessages() {
            let messages = 0;

            if ( Array.isArray(this.request.vertalingen) ) {
                this.request.vertalingen.forEach( (v) => {
                    if ( Array.isArray(v.opdrachtnemers) && v.opdrachtnemers.length ) {
                        v.opdrachtnemers.forEach( (o) => {
                            if (o.opdrachtnemer_id == this.user.opdrachtnemer.id) {
                                messages += o.berichten_count;
                            }
                        });
                    }
                });
            }

            return messages;
        },
        buttons() {

            let buttons = [{
                label: ( this.showRequestDetail ) ? 'Details verbergen' : 'Details tonen',
                action: () => {
                    this.showRequestDetail = !this.showRequestDetail;
                },
            }];

            if ( !this.withdrawn && !this.completed && (this.user.is_applicant || this.user.is_planner) ) {

                buttons.push({
                    label: 'Aanvraag bewerken',
                    action: this.edit
                });

                if (this.user.is_planner) {

                    buttons.push({
                        label: 'Aanvraag afronden',
                        action: this.wrapUp
                    });
                }

                buttons.push(
                    {
                        label: 'Aanvraag annuleren',
                        action: this.cancel
                    });
            }

            if ( !this.rejected && this.user.is_applicant ) {

                buttons.push({
                    label: 'Aanvraag afkeuren',
                    action: () => {
                        this.modal.reject = true;
                    }
                });
            }

            return buttons;
        },

        sourceLanguage() {

            if (
                this.request &&
                this.request.vertalingen &&
                this.request.vertalingen.length ){

                return this.request.vertalingen[0].brontaal.taal;
            }

            return '-'
        },

        targetLanguages() {

            let list = [];

            if (
                this.request &&
                this.request.vertalingen &&
                this.request.vertalingen.length ){

                this.request.vertalingen.forEach( (v) => {
                    list.push(v.doeltaal.taal);
                });
            }

            return ( list.length ) ? list.join(', ') : '-';
        },

        atLocation() {
            return this.request.is_tolk_opdracht == 1;
        },

        ownAssignment() {

            let assignment = null;

            if ( this.user.opdrachtnemer ) {

                this.request.vertalingen.forEach( (v) => {
                    if ( v.opdrachtnemers ) {
                        let found = v.opdrachtnemers.filter( o =>  o.opdrachtnemer.id == this.user.opdrachtnemer.id ).pop();

                        if ( found ){
                            assignment = found
                            return;
                        }
                    }
                });
            }

            return assignment;
        },

        isOwnRequest() {
            return this.user.opdrachtgever?.organisatie_id === this.request.opdrachtgever.organisatie_id;
        },

        accepted() {

            let accepted = [];

            this.request.vertalingen.forEach( (v) => {
                if ( v.opdrachtnemers ) {
                    accepted = [...accepted, ...v.opdrachtnemers.filter( o => o.geaccepteerd_at != undefined && o.ingetrokken_at == undefined )];
                }
            });

            return accepted;
        },

        withdrawn() {
            return this.request.status == 'Geannuleerd';
        },

        finished() {
            return this.request.status == 'Gereed';
        },

        completed() {
            return this.request.status == 'Afgerond';
        },

        rejected() {
            return this.request.status == 'Afgekeurd';
        },

        acceptedText() {

            if (this.user?.is_translator) {
                return 'Bedankt voor het accepteren van de tolkdienst';
            }

            let names = [];

            this.accepted.forEach( (a) => {
                names.push(a.opdrachtnemer.user.name);
            });

            let prefix = names.join(',');
            prefix += ( names.length > 1 ) ? ' hebben' : ' heeft';

            return  prefix + ' de aanvraag geaccepteerd en zal op de aangeven datum, tijd en locatie aanwezig zijn';
        },

        sourcefiles() {

            if ( this.request.media ) {
                return this.request.media.filter( m => m.collection_name == 'bronbestanden' );
            }

            return [];
        },

        referencefiles() {

            if ( this.request.media ) {
                return this.request.media.filter( m => m.collection_name == 'referentiemateriaal' );
            }

            return [];
        },

        ...mapState({
            request: (state) => state.request.data
        })
    },
    mounted() {
        this.$store.dispatch('request/load', this.$route.params.id).then( () => {
            this.loading = false;
        }).catch( (e) => {
            this.$store.dispatch('toasts/alert', {title: 'Aanvraag laden', text: 'Helaas kon de aanvraag niet geladen worden'});
        });
    }
}
</script>
